import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { Header } from './components/Header';
import { WarehouseGrid } from './components/WarehouseGrid';
import { WarehouseDetails } from './components/WarehouseDetails';
import { QuotesPage } from './pages/QuotesPage';
import { DesignPage } from './pages/DesignPage';
import { HomePageAlternative } from './pages/HomePageAlternative';
import { HomePageAlternative2 } from './pages/HomePageAlternative2';
import { DashboardPage } from './pages/DashboardPage';
import { DashboardPageAlternative } from './pages/DashboardPageAlternative';
import { OrdersPage } from './pages/OrdersPage';
import { NewQuotePage } from './pages/NewQuotePage';
import { ViewQuotePage } from './components/quotes/ViewQuotePage';
import { DealersPage } from './pages/DealersPage';
import { DealerDetailsPage } from './pages/DealerDetailsPage';
import { AdminPage } from './pages/AdminPage';
import { CustomerSupportPage } from './pages/CustomerSupportPage';
import { ClaimsReportsPage } from './pages/ClaimsReportsPage';
import { BusinessIntelligencePage } from './pages/BusinessIntelligencePage';
import { BusinessIntelligencePageV2 } from './pages/BusinessIntelligencePageV2';
import { SystemSettingsPage } from './pages/SystemSettingsPage';
import { FairProvider } from './contexts/FairContext';
import { ICADPage } from './pages/ICADPage';
import { ImpersonationBar } from './components/ImpersonationBar';
// Wrapper component to handle navigation
function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [activePage, setActivePage] = useState('home');
  const [selectedQuote, setSelectedQuote] = useState(null);
  const [isNewQuote, setIsNewQuote] = useState(false);
  const [isEditingQuote, setIsEditingQuote] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  // Update activePage based on current route
  useEffect(() => {
    const path = location.pathname;
    if (path === '/') setActivePage('home');else if (path === '/home2') setActivePage('home');else if (path === '/dashboard') setActivePage('dashboard');else if (path === '/design') setActivePage('design');else if (path === '/quotes') setActivePage('quotes');else if (path === '/order') setActivePage('order');else if (path === '/dealers') setActivePage('dealers');else if (path.includes('/dealers/')) setActivePage('dealers');else if (path === '/warehouses') setActivePage('warehouses');else if (path === '/support') setActivePage('support');else if (path.includes('/support/')) setActivePage('support');else if (path === '/admin') setActivePage('admin');else if (path === '/business-intelligence') setActivePage('business-intelligence');else if (path === '/business-intelligence-v2') setActivePage('business-intelligence-v2');else if (path === '/icad') setActivePage('icad');else if (path === '/subscription') setActivePage('subscription');else if (path === '/settings') setActivePage('settings');
  }, [location]);
  const handleViewDetails = warehouse => {
    setSelectedWarehouse(warehouse);
  };
  const handleBackToList = () => {
    setSelectedWarehouse(null);
  };
  const handleNavigate = page => {
    setActivePage(page);
    setSelectedWarehouse(null);
    setSelectedQuote(null);
    setIsNewQuote(false);
    setIsEditingQuote(false);
    // Map page identifier to actual route
    switch (page) {
      case 'home':
        navigate('/');
        break;
      case 'dashboard':
        navigate('/dashboard');
        break;
      case 'design':
        navigate('/design');
        break;
      case 'quotes':
        navigate('/quotes');
        break;
      case 'order':
        navigate('/order');
        break;
      case 'dealers':
        navigate('/dealers');
        break;
      case 'warehouses':
        navigate('/warehouses');
        break;
      case 'support':
        navigate('/support');
        break;
      case 'admin':
        navigate('/admin');
        break;
      case 'business-intelligence':
        navigate('/business-intelligence');
        break;
      case 'business-intelligence-v2':
        navigate('/business-intelligence-v2');
        break;
      case 'icad':
        navigate('/icad');
        break;
      case 'subscription':
        navigate('/subscription');
        break;
      case 'settings':
        navigate('/settings');
        break;
      default:
        navigate('/');
    }
  };
  const handleNewQuote = () => {
    setIsNewQuote(true);
    setIsEditingQuote(false);
  };
  const handleViewQuote = quote => {
    setSelectedQuote(quote);
    setIsNewQuote(false);
    setIsEditingQuote(false);
  };
  const handleBackToQuotes = () => {
    setSelectedQuote(null);
    setIsNewQuote(false);
    setIsEditingQuote(false);
  };
  const handleEditQuote = () => {
    // Activar el modo de edición para la cotización seleccionada
    setIsEditingQuote(true);
    setIsNewQuote(false);
  };
  // Handle toggling the sidebar state
  const handleToggleSidebar = (forceCollapse = false) => {
    if (forceCollapse) {
      setSidebarCollapsed(true);
    } else {
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };
  return <div className="flex flex-col w-full h-screen overflow-hidden bg-gray-100" data-id="element-0">
      <ImpersonationBar data-id="element-1" />
      <div className="flex flex-1 overflow-hidden" data-id="element-2">
        {activePage !== 'icad' && <Sidebar onNavigate={handleNavigate} activePage={activePage} collapsed={sidebarCollapsed} onToggleSidebar={handleToggleSidebar} data-id="element-3" />}
        <div className="flex-1 flex flex-col overflow-auto transition-all duration-300" data-id="element-4">
          {activePage === 'warehouses' && !selectedWarehouse && <Header data-id="element-5" />}
          <main className="flex-1 bg-gray-100" data-id="element-6">
            <Routes data-id="element-7">
              <Route path="/" element={<HomePageAlternative onNavigate={handleNavigate} data-id="element-9" />} data-id="element-8" />
              <Route path="/home2" element={<HomePageAlternative2 onNavigate={handleNavigate} data-id="element-11" />} data-id="element-10" />
              <Route path="/warehouses" element={selectedWarehouse ? <WarehouseDetails {...selectedWarehouse} onBack={handleBackToList} data-id="element-13" /> : <div className="p-6" data-id="element-14">
                      <WarehouseGrid onViewDetails={handleViewDetails} data-id="element-15" />
                    </div>} data-id="element-12" />
              <Route path="/quotes" element={isNewQuote || isEditingQuote ? <NewQuotePage onBack={handleBackToQuotes} isEditing={isEditingQuote} quoteData={isEditingQuote ? selectedQuote : null} data-id="element-17" /> : selectedQuote ? <ViewQuotePage quoteData={selectedQuote} onBack={handleBackToQuotes} onEdit={handleEditQuote} data-id="element-18" /> : <QuotesPage onNewQuote={handleNewQuote} onViewQuote={handleViewQuote} onToggleSidebar={handleToggleSidebar} data-id="element-19" />} data-id="element-16" />
              <Route path="/dealers" element={<DealersPage data-id="element-21" />} data-id="element-20" />
              <Route path="/dealers/:dealerId" element={<DealerDetailsPage data-id="element-23" />} data-id="element-22" />
              <Route path="/design" element={<DesignPage data-id="element-25" />} data-id="element-24" />
              <Route path="/dashboard" element={<DashboardPageAlternative data-id="element-27" />} data-id="element-26" />
              <Route path="/order" element={<OrdersPage data-id="element-29" />} data-id="element-28" />
              <Route path="/support" element={<CustomerSupportPage data-id="element-31" />} data-id="element-30" />
              <Route path="/support/claims/reports" element={<ClaimsReportsPage data-id="element-33" />} data-id="element-32" />
              <Route path="/admin" element={<AdminPage data-id="element-35" />} data-id="element-34" />
              <Route path="/business-intelligence" element={<BusinessIntelligencePage data-id="element-37" />} data-id="element-36" />
              <Route path="/business-intelligence-v2" element={<BusinessIntelligencePageV2 data-id="element-39" />} data-id="element-38" />
              <Route path="/icad" element={<ICADPage onNavigate={handleNavigate} data-id="element-41" />} data-id="element-40" />
              <Route path="/settings" element={<SystemSettingsPage data-id="element-43" />} data-id="element-42" />
              <Route path="*" element={<div className="p-6 flex items-center justify-center h-full" data-id="element-45">
                    <div className="text-center" data-id="element-46">
                      <h2 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-47">
                        Page Not Found
                      </h2>
                      <p className="text-gray-600" data-id="element-48">
                        The page you are looking for does not exist
                      </p>
                    </div>
                  </div>} data-id="element-44" />
            </Routes>
          </main>
        </div>
      </div>
    </div>;
}
export function App() {
  return <Router data-id="element-49">
      <FairProvider data-id="element-50">
        <AppContent data-id="element-51" />
      </FairProvider>
    </Router>;
}